import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import KYC from "../CustomerDetails/KYCLegacy/KYC";
import KYCNew from "../CustomerDetails/KYCNew/KYCNew";
import UserAccounts from "../CustomerDetails/UserAccounts/UserAccounts";
import CommunicationTab from "../CustomerDetails/CommunicationTab/CommunicationTab";
import NotificationsTab from "../CustomerDetails/NotificationsTab/NotificationsTab";
import TransactionTab from "../TransactionTab/TransactionTab";
import CardTabs from "../CardTabs/CardTabs";
import LoanTab from "../LoanTab/LoanTab";
import LoansTab4Pay from "../LoansTabNew/LoansTab4Pay";
import CRMRoleTab from "../CRMRoleTab/CRMRoleTab";
import UserAccountTransfers from "../AccountActionsComponents/UserAccountTransfers/UserAccountTransfers";
import { useSelector } from "react-redux";
import CAErrorMessage from "../ErrorTab/CAErrorTab";
import GroupLoansTab from "../GroupLoansTab/GroupLoansTab";
import UserNotes from "../CustomerDetails/UserNotes/UserNotes";
import OFACHistory from "../CustomerDetails/OFACHistory/OFACHistory";
import UserDevices from "../UserDevices/UserDevices";
import ScoreHistory from "../CustomerDetails/ScoreHistory/ScoreHistory";

export function CustomTabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <Box
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
      style={{
        backgroundColor: "white",
        borderRadius: "12px",
      }}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </Box>
  );
}

CustomTabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

export default function AccountTabs({
  selectedUser,
  selectedUserData,
  setSelectedUserData,
  setRoleChanged,
  setProfileStatusChanged,
  updateTableStatus,
  roleChanged,
  handleSelectedUser,
  isAssociateAgent,
  isSuperAdmin,
  handleClose,
  tabPermissions
}) {
  const [value, setValue] = useState(0);
  let isAdmin = sessionStorage.getItem("isAdmin");
  let isSuperAgent = sessionStorage.getItem("isSuperAgent");

  let configVariables = useSelector((state) => state.config.baseConfig);

  // console.log("tabPermissions----------------",tabPermissions)

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  useEffect(() => {
    setValue(0);
  }, [selectedUser]);

  // const tabs = (
  //   isAssociateAgent
  //     ? [
  //         {
  //           label: "KYC/KYB/KYA",
  //           component: (
  //             <KYC
  //               selectedUser={selectedUser}
  //               selectedUserData={selectedUserData}
  //               setSelectedUserData={setSelectedUserData}
  //               handleSelectedUser={handleSelectedUser}
  //             />
  //           ),
  //         },
  //       ]
  //     : [
  //         {
  //           label: "Accounts",
  //           component: (
  //             <UserAccounts
  //               selectedUser={selectedUser}
  //               selectedUserData={selectedUserData}
  //               setSelectedUserData={setSelectedUserData}
  //               isSuperAdmin={isSuperAdmin}
  //             />
  //           ),
  //         },
  //         {
  //           label: "Card",
  //           component: (
  //             <CardTabs
  //               selectedUser={selectedUser}
  //               selectedUserData={selectedUserData}
  //               setSelectedUserData={setSelectedUserData}
  //             />
  //           ),
  //         },
  //         { label: "Transfers", component: <UserAccountTransfers /> },
  //         {
  //           label: "Communications",
  //           component: (
  //             <CommunicationTab
  //               selectedUser={selectedUser}
  //               selectedUserData={selectedUserData}
  //               setSelectedUserData={setSelectedUserData}
  //             />
  //           ),
  //         },
  //         {
  //           label: "Error",
  //           component: (
  //             <CAErrorMessage
  //               selectedUser={selectedUser}
  //             />
  //           ),
  //         },
  //         {
  //           label: "Transactions",
  //           component: (
  //             <TransactionTab
  //               selectedUser={selectedUser}
  //               selectedUserData={selectedUserData}
  //               setSelectedUserData={setSelectedUserData}
  //               type="transactionHistory"
  //             />
  //           ),
  //         },
  //         {
  //           label: "KYC/KYB/KYA",
  //           component: (
  //             <KYC
  //               selectedUser={selectedUser}
  //               selectedUserData={selectedUserData}
  //               setSelectedUserData={setSelectedUserData}
  //               updateTableStatus={updateTableStatus}
  //               handleSelectedUser={handleSelectedUser}
  //             />
  //           ),
  //         },
  //         {
  //           label: "Vouchers",
  //           component: (
  //             <TransactionTab
  //               selectedUser={selectedUser}
  //               selectedUserData={selectedUserData}
  //               setSelectedUserData={setSelectedUserData}
  //               type="voucherHistory"
  //             />
  //           ),
  //         },
  //         {
  //           label: "Loan",
  //           component: (
  //             <LoanTab
  //               selectedUser={selectedUser}
  //               selectedUserData={selectedUserData}
  //               setSelectedUserData={setSelectedUserData}
  //             />
  //           ),
  //         },
  //         configVariables.devEnvironment && 
  //         [
  //           {
  //             label: "4Pay Loans",
  //             component: (
  //               <LoansTab4Pay
  //                 selectedUser={selectedUser}
  //                 selectedUserData={selectedUserData}
  //                 setSelectedUserData={setSelectedUserData}
  //               />
  //             ),
  //           },
  //           {
  //             label: "Group Loans",
  //             component: (
  //               <GroupLoansTab
  //                 selectedUser={selectedUser}
  //                 selectedUserData={selectedUserData}
  //                 setSelectedUserData={setSelectedUserData}
  //               />
  //             ),
  //           }
  //         ],
          
  //         ...(isAdmin === "true"
  //           ? [
  //               {
  //                 label: "Access",
  //                 component: (
  //                   <CRMRoleTab
  //                     setRoleChanged={setRoleChanged}
  //                     setProfileStatusChanged={setProfileStatusChanged}
  //                     updateTableStatus={updateTableStatus}
  //                     roleChanged={roleChanged}
  //                     handleSelectedUser={handleSelectedUser}
  //                     selectedUser={selectedUser}
  //                     selectedUserData={selectedUserData}
  //                     handleClose={handleClose}
  //                   />
  //                 ),
  //               },
  //             ]
  //           : 
  //           isSuperAgent === "true" ? [
  //             {
  //               label: "Access",
  //               component: (
  //                 <CRMRoleTab
  //                   setRoleChanged={setRoleChanged}
  //                   setProfileStatusChanged={setProfileStatusChanged}
  //                   updateTableStatus={updateTableStatus}
  //                   roleChanged={roleChanged}
  //                   handleSelectedUser={handleSelectedUser}
  //                   selectedUser={selectedUser}
  //                   selectedUserData={selectedUserData}
  //                   handleClose={handleClose}
  //                 />
  //               ),
  //             },
  //           ] : []),
  //       ]
  // ).flat();

  const orderedTabs = [
    {
      appid: "41200002",
      label: "Accounts",
      component: (
        <UserAccounts
          selectedUser={selectedUser}
          selectedUserData={selectedUserData}
          setSelectedUserData={setSelectedUserData}
          isSuperAdmin={isSuperAdmin}
        />
      ),
    },
    {
      appid: "50000001",
      label: "User Notes",
      component: (
        <UserNotes
          selectedUser={selectedUser}
          selectedUserData={selectedUserData}
          setSelectedUserData={setSelectedUserData}
          isSuperAdmin={isSuperAdmin}
        />
      ),
    },
    {
      appid: "50000001",
      label: "Score History",
      component: (
        <ScoreHistory
          selectedUser={selectedUser}
          selectedUserData={selectedUserData}
          setSelectedUserData={setSelectedUserData}
          isSuperAdmin={isSuperAdmin}
        />
      ),
    },
    {
      appid: "41100002",
      label: "Card",
      component: (
        <CardTabs
          selectedUser={selectedUser}
          selectedUserData={selectedUserData}
          setSelectedUserData={setSelectedUserData}
        />
      ),
    },
    {
      appid: "49000002",
      label: "Transfers",
      component: <UserAccountTransfers selectedUserData={selectedUserData} />,
    },
    {
      appid: "48000002",
      label: "Communications",
      component: (
        <CommunicationTab
          selectedUser={selectedUser}
          selectedUserData={selectedUserData}
          setSelectedUserData={setSelectedUserData}
        />
      ),
    },
    {
      appid: "50000002",
      label: "Notifications",
      component: (
        <NotificationsTab
          selectedUser={selectedUser}
          selectedUserData={selectedUserData}
          setSelectedUserData={setSelectedUserData}
        />
      ),
    },
    {
      appid: "47000002",
      label: "Error",
      component: <CAErrorMessage selectedUser={selectedUser} />,
    },
    {
      appid: "46000002",
      label: "Transactions",
      component: (
        <TransactionTab
          selectedUser={selectedUser}
          selectedUserData={selectedUserData}
          setSelectedUserData={setSelectedUserData}
          type="transactionHistory"
        />
      ),
    },
    {
      appid: "45000002",
      label: "KYC/KYB/KYA",
      component: (
        <KYC
          selectedUser={selectedUser}
          selectedUserData={selectedUserData}
          setSelectedUserData={setSelectedUserData}
          updateTableStatus={updateTableStatus}
          handleSelectedUser={handleSelectedUser}
        />
      ),
    },
    {
      appid: "50000004",
      label: "KYC Enhanced",
      component: (
        <KYCNew
          selectedUser={selectedUser}
          selectedUserData={selectedUserData}
          setSelectedUserData={setSelectedUserData}
          updateTableStatus={updateTableStatus}
          handleSelectedUser={handleSelectedUser}
        />
      ),
    },
    {
      appid: "50000005",
      label: "OFAC History",
      component: (
        <OFACHistory
          selectedUser={selectedUser}
          selectedUserData={selectedUserData}
          setSelectedUserData={setSelectedUserData}
          updateTableStatus={updateTableStatus}
          handleSelectedUser={handleSelectedUser}
        />
      ),
    },
    {
      appid: "44000002",
      label: "Vouchers",
      component: (
        <TransactionTab
          selectedUser={selectedUser}
          selectedUserData={selectedUserData}
          setSelectedUserData={setSelectedUserData}
          type="voucherHistory"
        />
      ),
    },
    {
      appid: "43000002",
      label: "Loan",
      component: (
        <LoanTab
          selectedUser={selectedUser}
          selectedUserData={selectedUserData}
          setSelectedUserData={setSelectedUserData}
        />
      ),
    },
    {
      appid: "41000002",
      label: "4Pay Loans",
      component: (
        <LoansTab4Pay
          selectedUser={selectedUser}
          selectedUserData={selectedUserData}
          setSelectedUserData={setSelectedUserData}
        />
      ),
    },
    {
      appid: "50000003",
      label: "Group Loans",
      component: (
        <GroupLoansTab
          selectedUser={selectedUser}
          selectedUserData={selectedUserData}
          setSelectedUserData={setSelectedUserData}
        />
      ),
    },
    {
      appid: "50000006",
      label: "User Devices",
      component: (
        <UserDevices
          selectedUser={selectedUser}
          selectedUserData={selectedUserData}
          setSelectedUserData={setSelectedUserData}
        />
      ),
    },
    {
      appid: "42000002",
      label: "Access",
      component: (
        <CRMRoleTab
          setRoleChanged={setRoleChanged}
          setProfileStatusChanged={setProfileStatusChanged}
          updateTableStatus={updateTableStatus}
          roleChanged={roleChanged}
          handleSelectedUser={handleSelectedUser}
          selectedUser={selectedUser}
          selectedUserData={selectedUserData}
          handleClose={handleClose}
        />
      ),
    },
  ];

  const tabs = [];
  orderedTabs.forEach(({ appid, label, component }) => {
    const permission = tabPermissions && tabPermissions[appid];
    // console.log(orderedTabs)

    if (permission) {
      tabs.push({ label, component });
    }
  });


  return (
    <Box sx={{ width: "100%" }}>
      <Box
        sx={{
          backgroundColor: "#f8f8f8",
          position: "sticky",
          top: 0,
          zIndex: 1,
        }}
      >
        <Tabs
          value={value}
          onChange={handleChange}
          variant="scrollable"
          scrollButtons="auto"
          allowScrollButtonsMobile
          TabIndicatorProps={{ style: { display: "none" } }}
          sx={{
            "& .MuiTab-root": {
              textTransform: "capitalize",
              // color: "#BCBCBC",
              color: "#4b4b4b",
              fontFamily: "Inter",
              fontSize: 15,
              fontStyle: "normal",
              fontWeight: 400,
              lineHeight: "30px",
              backgroundColor: "#f8f8f8",
              "&.Mui-selected": {
                backgroundColor: "white",
                // color: "#5523D2",
                color: "#00365A",
                borderRadius: "6px 6px 0 0 !important",
                textAlign: "center",
                fontSize: 15,
                fontStyle: "normal",
                fontWeight: 600,
                lineHeight: "30px",
                borderBottom: 0,
                borderBottomColor: "#FAC800",
                borderBottomWidth: 4,
              },
            },
          }}
        >
          {tabs.map((tab, index) => (
            <Tab
              key={index}
              label={tab.label}
              {...a11yProps(index)}
              disabled={selectedUserData === null}
            />
          ))}
        </Tabs>
      </Box>
      {tabs.map((tab, index) => (
        <CustomTabPanel key={index} value={value} index={index}>
          {tab.component}
        </CustomTabPanel>
      ))}
    </Box>
  );
}
